// extracted by mini-css-extract-plugin
module.exports = {"visualitzacioSelector":"IntroduccioObservador_visualitzacioSelector__171LV"};